import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { stopRolePreview } from '@application/features/auth/authSlice';
export const ROLE_PREVIEW_BANNER_TOP_OFFSET = 16;
export const ROLE_PREVIEW_BANNER_HEIGHT = 44;
export const ROLE_PREVIEW_BANNER_TOTAL_OFFSET = ROLE_PREVIEW_BANNER_TOP_OFFSET + ROLE_PREVIEW_BANNER_HEIGHT;
export default function RolePreviewBanner() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const previewRoleLabel = useSelector((state) => state.auth.previewRoleLabel);
    return (_jsx(Box, { sx: {
            position: 'fixed',
            top: ROLE_PREVIEW_BANNER_TOP_OFFSET,
            left: 0,
            right: 0,
            zIndex: (theme) => theme.zIndex.appBar + 10,
            display: 'flex',
            justifyContent: 'center',
            px: 2,
            pointerEvents: 'none',
        }, children: _jsx(Alert, { severity: "warning", icon: _jsx(Icon, { icon: "solar:eye-bold", width: 18 }), sx: {
                pointerEvents: 'auto',
                width: 'auto',
                maxWidth: 'min(920px, 100%)',
                minHeight: ROLE_PREVIEW_BANNER_HEIGHT,
                borderRadius: 2,
                alignItems: 'center',
                py: 0.75,
                px: 2,
                boxShadow: '0px 8px 24px rgba(36, 35, 71, 0.12)',
                '& .MuiAlert-message': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    width: '100%',
                    gap: 2,
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                },
            }, action: _jsx(Button, { size: "small", color: "warning", variant: "outlined", onClick: () => { dispatch(stopRolePreview()); navigate('/'); }, startIcon: _jsx(Icon, { icon: "solar:close-circle-bold", width: 16 }), sx: { whiteSpace: 'nowrap', mr: 0 }, children: t('rolePreview.exitPreview') }), children: _jsx(Typography, { variant: "body2", fontWeight: 600, children: t('rolePreview.previewingAs', { role: previewRoleLabel ? t(previewRoleLabel) : '' }) }) }) }));
}
